import type { SurveyAnswerFlattenedValue, SurveyElementJson, SurveyImageAnswerValue } from '../types'

export function getTypedAnswerValue(
  question: SurveyElementJson & {
    type: 'radiogroup'
  },
  answerValue: SurveyAnswerFlattenedValue | undefined,
): string | undefined

export function getTypedAnswerValue(
  question: SurveyElementJson & {
    type: 'checkbox'
  },
  answerValue: SurveyAnswerFlattenedValue | undefined,
): string[] | undefined

export function getTypedAnswerValue(
  question: SurveyElementJson & {
    type: 'boolean'
  },
  answerValue: SurveyAnswerFlattenedValue | undefined,
): boolean | undefined

export function getTypedAnswerValue(
  question: SurveyElementJson & {
    type: 'ranking'
  },
  answerValue: SurveyAnswerFlattenedValue | undefined,
): string[] | undefined

export function getTypedAnswerValue(
  question: SurveyElementJson & {
    type: 'imagepicker'
  },
  answerValue: SurveyAnswerFlattenedValue | undefined,
): string | string[] | undefined

export function getTypedAnswerValue(
  question: SurveyElementJson & {
    type: 'file'
  },
  answerValue: SurveyAnswerFlattenedValue | undefined,
): SurveyImageAnswerValue[] | undefined

export function getTypedAnswerValue(
  question: SurveyElementJson & {
    type: 'dropdown'
  },
  answerValue: SurveyAnswerFlattenedValue | undefined,
): string | undefined

export function getTypedAnswerValue<T extends SurveyElementJson>(
  question: T,
  answerValue: SurveyAnswerFlattenedValue | undefined,
): string | string[] | boolean | SurveyImageAnswerValue[] | undefined {
  if (answerValue === undefined) {
    return undefined
  }

  switch (question.type) {
  case 'radiogroup':
    return answerValue as string
  case 'checkbox':
    return answerValue as string[]
  case 'boolean':
    return answerValue as boolean
  case 'ranking':
    return answerValue as string[]
  case 'imagepicker':
    return answerValue as string | string[]
  case 'file':
    return answerValue as SurveyImageAnswerValue[]
  case 'dropdown':
    return answerValue as string
  default:
    throw new Error(`Not implemented question type: ${(question as any).type}`)
  }
}

export function getTypedAnswerCommentValue(
  answerValue: SurveyAnswerFlattenedValue | undefined,
) {
  if (answerValue === undefined) {
    return undefined
  }

  return answerValue as string
}
